module.exports = __webpack_public_path__ + "static/Site-5-5adc7ea7b81d782de907210a0f4277ca.jpg";